/* eslint-env browser */
export default {
  getDriver: (store) => {
    window.store = store
    return window
  },
}
